import React from 'react'
import { Link } from 'react-router-dom'
import { SprintSpecLogo } from '../Logo/SprintSpecLogo'

export const AppLogo = () => {
  return (
    <Link to="/app/documents" className="no-underline">
      <SprintSpecLogo />
    </Link>
  )
}
